"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Carousel = _interopRequireDefault(require("../../Carousel/Carousel"));
var _Card = _interopRequireDefault(require("../../Card/Card"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var FlexSliderAndText = function FlexSliderAndText(_ref) {
  var slides = _ref.slides,
    content = _ref.content,
    title = _ref.title,
    reorderOnMobile = _ref.reorderOnMobile;
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
    className: "max-width-md"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-center margin-bottom-xl"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center@sm flex-gap-xl margin-top-md flex-column flex-row@sm"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6@sm ".concat(reorderOnMobile && 'order-1@sm order-2')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component",
    dangerouslySetInnerHTML: {
      __html: content
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6@sm ".concat(reorderOnMobile && 'order-2@sm order-1')
  }, /*#__PURE__*/_react["default"].createElement(_Carousel["default"], null, slides.map(function (slide) {
    return /*#__PURE__*/_react["default"].createElement(_Card["default"], {
      key: JSON.stringify(slide),
      template: "ImageCard",
      size: "xl",
      bgImage: slide.background
    });
  })))));
};
FlexSliderAndText.propTypes = {
  slides: _propTypes["default"].array.isRequired,
  content: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string.isRequired,
  reorderOnMobile: _propTypes["default"].bool
};
var _default = exports["default"] = FlexSliderAndText;